/* eslint-disable import/prefer-default-export */
import {
  MATERIAL_TYPE_ALL,
  MATERIAL_TYPE_GET,
  MATERIAL_TYPE_POST,
  MATERIAL_TYPE_PUT,
  MATERIAL_TYPE_DEL,
  MATERIAL_TYPE_LOADING,
  MATERIAL_TYPE_ERROR,
} from '../types';

import api from '../../../utils/functions/api';

export const materialTypeCreate = (payload) => async (dispatch) => {
  try {
    dispatch({ type: MATERIAL_TYPE_LOADING });
    const { data } = await api.post(
      `${process.env.REACT_APP_API_URL}/material-type`,
      payload,
    );
    dispatch({ type: MATERIAL_TYPE_POST, payload: data });
  } catch (error) {
    console.error(error);
    dispatch({ type: MATERIAL_TYPE_ERROR });
    throw new Error(error);
  }
};

export const materialTypeAll = (params) => async (dispatch) => {
  try {
    const { name = '', size = null, page = 1 } = params;
    const { data, status } = await api.get(
      `${process.env.REACT_APP_API_URL}/material-type?name=${name}&size=${size}&page=${page}`,
    );
    if (status === 200) {
      dispatch({ type: MATERIAL_TYPE_ALL, payload: data });
    }
  } catch (error) {
    console.error(error);
    dispatch({ type: MATERIAL_TYPE_ERROR });
    throw new Error(error);
  }
};

export const materialTypeGet = (id) => async (dispatch) => {
  try {
    dispatch({ type: MATERIAL_TYPE_LOADING });
    const { data, status } = await api.get(
      `${process.env.REACT_APP_API_URL}/material-type/${id}`,
    );
    if (status === 200) {
      dispatch({ type: MATERIAL_TYPE_GET, payload: data });
    }
  } catch (error) {
    console.error(error);
    dispatch({ type: MATERIAL_TYPE_ERROR });
    throw new Error(error);
  }
};

export const materialTypePut = (id, payload) => async (dispatch) => {
  try {
    dispatch({ type: MATERIAL_TYPE_LOADING });
    const { data, status } = await api.put(
      `${process.env.REACT_APP_API_URL}/material-type/${id}`,
      payload,
    );
    if (status === 200) {
      dispatch({ type: MATERIAL_TYPE_PUT, payload: data });
    }
  } catch (error) {
    console.error(error);
    dispatch({ type: MATERIAL_TYPE_ERROR });
    throw new Error(error);
  }
};

export const materialTypeDelete = (id) => async (dispatch) => {
  try {
    dispatch({ type: MATERIAL_TYPE_LOADING });
    const { data } = await api.delete(
      `${process.env.REACT_APP_API_URL}/material-type/${id}`,
    );
    dispatch({ type: MATERIAL_TYPE_DEL, payload: data });
  } catch (error) {
    console.error(error);
    dispatch({ type: MATERIAL_TYPE_ERROR });
    throw new Error(error);
  }
};
